export enum PricingType {
	Promo = 0,
	Standard = 1,
	PriceOverride = 2
}